import React, { useState } from "react";
import { api } from "@/lib/api";
import { NOW, nowOf } from "@/lib/stages";
import { NowPicker } from "@/components/portal/sys/NowPicker";
import { NowDialog } from "@/components/portal/sys/NowDialog";
import { toast } from "sonner";

/** Connexis posts or clears a Right now update on one desk's lane, exactly as the desk would. */
export function HubLaneNow({ leadId, route, onDone }) {
  const [kind, setKind] = useState(null);
  const now = nowOf(route);
  if (route.withdrawn) return null;
  const send = async (status, payload = {}) => {
    try {
      await api.patch(`/hub/leads/${leadId}/routes/${route.lender_id}/now`, { status, ...payload });
      toast.success(NOW[status] ? "Update posted — the introducer has been emailed" : "Update cleared — back to Under assessment");
      setKind(null);
      onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "That didn't go through"); }
  };
  return (
    <>
      <NowPicker now={now} status={route.status} onPick={setKind} onClear={() => send("in_review")}
                 testId={`hub-route-now-${route.lender_id}`} />
      {kind && (
        <NowDialog kind={kind} current={now} onClose={() => setKind(null)}
                   onConfirm={(payload) => send(kind, payload)} testId="hub-now-dialog" />
      )}
    </>
  );
}

export default HubLaneNow;
